import React from 'react'
import { VictoryTooltip } from 'victory'

export const AreaChartTooltip = ({
    x,
    y,
    isCustom,
    formatDate,
    formatPrice,
    ...rest
}: any) => {
    return isCustom ? (
        <CustomFlyout
            {...rest}
            x={x - 80}
            y={20}
            formatPrice={formatPrice}
            formatDate={formatDate}
        />
    ) : (
        <VictoryTooltip
            constrainToVisibleArea
            x={x}
            y={y}
            cornerRadius={8}
            pointerLength={0}
            flyoutPadding={4}
            // flyoutComponent={
            //     <CustomFlyout
            //         formatDate={formatDate}
            //         formatPrice={formatPrice}
            //     />
            // }
            flyoutStyle={{
                fill: "#E8E8E8",
                stroke: ({ datum }) => '#333',
                borderRadius: 8
            }}
            {...rest}
        />
    )
}

const CustomFlyout = (props: any) => {
    const { x, y, formatDate, formatPrice, datum } = props;
    const fontSize = 11;
    const smallFontSize = 9;
    const tooltipWidth = 80
    const tooltipHeight = 40

    const valueColor = '#A4A7C1'
    const priceValueColor = '#626AFF';

    const halfTooltipWidth = tooltipWidth / 2;
    const leftThreshold = halfTooltipWidth;
    const rightThreshold = window.innerWidth - halfTooltipWidth;

    const xPos = x + halfTooltipWidth < leftThreshold
        ? 0
        : x + halfTooltipWidth > rightThreshold
            ? window.innerWidth
            : x

    return (
        // <svg>
        <g width={tooltipWidth} height={tooltipHeight} overflow="hidden" clipPath="url(#container_clip_path">
            <rect
                x={xPos} y={y + 2}
                fill="#fff"
                stroke="#E8E8E8"
                strokeWidth={1}
                width={tooltipWidth}
                height={tooltipHeight}
                rx={8}
            />
            
            {/* Price */}
            <svg width={tooltipWidth} height={tooltipHeight} x={xPos} y={y} dominantBaseline="middle" alignmentBaseline='middle' >
                <text x="50%"  y={y - 2} fontSize={fontSize} fill={priceValueColor} dominantBaseline="middle" alignmentBaseline='middle' textAnchor="middle">
                    {formatPrice?.(datum?.y)}
                </text>
            </svg>
            
            
            {/* Date */}
            <svg width={tooltipWidth} height={tooltipHeight} x={xPos} y={y} dominantBaseline="middle" alignmentBaseline='middle'>
                <text x="50%" y={y + 12} fontSize={smallFontSize} fill={valueColor} dominantBaseline="middle" alignmentBaseline='middle' textAnchor="middle">
                    {formatDate?.(datum?.x)}
                </text>
            </svg>

            
            {/* Line */}
            <rect
                x={x + halfTooltipWidth}
                y={y + tooltipHeight + 1}
                width={1}
                height={tooltipHeight * 3}
                fill={'#E8E8E8'}
            />
        </g>
        // </svg >
    )
}